import styled, { css } from 'styled-components';

import { rem, mediaHover } from 'approot/shared/style';
import { grey7, grey10, purple7 } from 'approot/shared/styles/colours.style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import {
  baseBoxShadowFocus,
  borderRadius16,
} from 'approot/shared/styles/borders.style';

type TooltipInfoStyledProps = {
  $isPurple?: boolean;
};

export const TooltipInfoStyled = styled.span<TooltipInfoStyledProps>`
  display: none;
  margin-left: ${rem(spacing8)};

  span {
    display: inline-block;
    vertical-align: middle;

    &:focus {
      outline: 0;
      svg {
        box-shadow: inset ${baseBoxShadowFocus};
        stroke: ${grey10};
      }
    }
  }

  svg {
    border-radius: ${rem(borderRadius16)};
    stroke: ${grey7};
  }

  ${({ $isPurple }) =>
    $isPurple &&
    css`
      svg {
        stroke: ${purple7} !important;
      }

      span:focus svg {
        stroke: ${purple7} !important;
      }
    `}

  ${mediaHover`
    display: inline;
  `}
`;
